var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.marketgroup && _vm.marketgroup.idfwmarketgroup
    ? _c(
        "div",
        {
          staticClass: "marketgroup oddsboost clearfix",
          class: ["counter-" + _vm.counter],
          attrs: {
            fluid: "",
            idfwmarketgroup: _vm.marketgroup.idfwmarketgroup.toString()
          }
        },
        [
          _vm.showMarketgroupName
            ? _c(
                "h3",
                {
                  staticClass: "name",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toggleCollapse()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.marketgroup.marketgroupname) + " ")]
              )
            : _vm._e(),
          _vm._v(" "),
          ["EVENTSPERCOMPETITION", "EVENTSPERDAY"].indexOf(_vm.eventsGrouping) >
            -1 &&
          (_vm.eventsGroupedByCompetition.length > 0 ||
            _vm.eventsGroupedByDateAndCompetition)
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExpanded,
                      expression: "isExpanded"
                    }
                  ],
                  staticClass: "coupon group-by-date"
                },
                [
                  _vm.isDebug
                    ? [
                        _vm._v(
                          "\n      eventsGrouping : " +
                            _vm._s(_vm.eventsGrouping) +
                            "\n      isOddsBoost: " +
                            _vm._s(_vm.isOddsBoost) +
                            "\n    "
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.eventsGroupedByCompetition, function(
                    fosport,
                    index
                  ) {
                    return _vm.eventsGrouping === "EVENTSPERCOMPETITION"
                      ? _c(
                          "div",
                          { key: index, staticClass: "date" },
                          [
                            _vm.isDebug
                              ? [
                                  _vm._v(
                                    "\n        fosportinternalorder " +
                                      _vm._s(fosport.fosportinternalorder) +
                                      "\n        isBig3Coupon " +
                                      _vm._s(_vm.isBig3Coupon(fosport.events)) +
                                      "\n      "
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            !fosport.events[0].markets[0].isoutright
                              ? _c(
                                  "div",
                                  [
                                    _vm.anyEventWithOddsBoostMarketsExist(
                                      fosport.events
                                    )
                                      ? _c("odds-boost-markets-header", {
                                          attrs: {
                                            coupontitle:
                                              _vm.marketgroup
                                                .idfwpopulationtype ===
                                              "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                ? fosport.fosportname
                                                : _vm.marketgroup
                                                    .marketgroupname,
                                            idfosporttype: _vm.getIDFOSportType(
                                              fosport.events[0]
                                            ),
                                            idfosport:
                                              fosport &&
                                              fosport.events &&
                                              fosport.events[0] &&
                                              fosport.events[0].idfosport
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(fosport.events, function(
                                      event,
                                      $index
                                    ) {
                                      return _vm.eventHasOddsBoostMarkets(event)
                                        ? _c(
                                            "div",
                                            {
                                              key: $index,
                                              class: [
                                                "event",
                                                {
                                                  last:
                                                    $index ===
                                                    fosport.events.length - 1
                                                },
                                                {
                                                  "big-three-one-selection-per-event":
                                                    _vm.isBig3Coupon(
                                                      fosport.events
                                                    ) &&
                                                    _vm.maxNumberOfMarkets(
                                                      fosport.events
                                                    ) === 1
                                                }
                                              ]
                                            },
                                            [
                                              _c("odds-boost-coupon-event", {
                                                attrs: {
                                                  event: event,
                                                  twoselections:
                                                    !_vm.isBig3Coupon(
                                                      fosport.events
                                                    ) &&
                                                    !_vm.hasDraw(
                                                      fosport.events
                                                    ),
                                                  threeselections:
                                                    !_vm.isBig3Coupon(
                                                      fosport.events
                                                    ) &&
                                                    _vm.hasDraw(fosport.events),
                                                  isbig3coupon: _vm.isBig3Coupon(
                                                    fosport.events
                                                  ),
                                                  couponname:
                                                    _vm.marketgroup
                                                      .idfwpopulationtype ===
                                                    "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                      ? fosport.fosportname
                                                      : _vm.marketgroup
                                                          .marketgroupname,
                                                  isOddsBoost: _vm.isOddsBoost
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.eventsGroupedByDateAndCompetition, function(
                    dateEvents,
                    date,
                    iterator
                  ) {
                    return _vm.eventsGrouping === "EVENTSPERDAY"
                      ? _c(
                          "div",
                          { key: iterator, staticClass: "date" },
                          [
                            _vm.isDateToday(date)
                              ? _c(
                                  "h4",
                                  { staticClass: "eventsperday_header" },
                                  [_vm._v(_vm._s(_vm.$t("BettingOffer.Today")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isDateTomorrow(date)
                              ? _c(
                                  "h4",
                                  { staticClass: "eventsperday_header" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("BettingOffer.Tomorrow"))
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isDateToday(date) && !_vm.isDateTomorrow(date)
                              ? _c(
                                  "h4",
                                  { staticClass: "eventsperday_header" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          date,
                                          _vm.dateFormats.shortDateMG
                                        )
                                      ) + " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(dateEvents, function(fosport, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "date-events" },
                                [
                                  !fosport.events[0].markets[0].isoutright
                                    ? _c(
                                        "div",
                                        [
                                          _vm.anyEventWithOddsBoostMarketsExist(
                                            fosport.events
                                          )
                                            ? _c("odds-boost-markets-header", {
                                                attrs: {
                                                  coupontitle:
                                                    _vm.marketgroup
                                                      .idfwpopulationtype ===
                                                    "NEXTOFFBYSPORTTYPEMKTTYPCLASSPER"
                                                      ? fosport.fosportname
                                                      : _vm.marketgroup
                                                          .marketgroupname,
                                                  idfosporttype: _vm.getIDFOSportType(
                                                    fosport.events[0]
                                                  ),
                                                  idfosport:
                                                    fosport &&
                                                    fosport.events &&
                                                    fosport.events[0] &&
                                                    fosport.events[0].idfosport
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(fosport.events, function(
                                            event,
                                            $index
                                          ) {
                                            return _vm.eventHasOddsBoostMarkets(
                                              event
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: $index,
                                                    class: [
                                                      "event",
                                                      {
                                                        last:
                                                          $index ===
                                                          fosport.events
                                                            .length -
                                                            1
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _c(
                                                      "odds-boost-coupon-event",
                                                      {
                                                        attrs: {
                                                          event: event,
                                                          twoselections:
                                                            !_vm.isBig3Coupon(
                                                              fosport.events
                                                            ) &&
                                                            !_vm.hasDraw(
                                                              fosport.events
                                                            ),
                                                          threeselections:
                                                            !_vm.isBig3Coupon(
                                                              fosport.events
                                                            ) &&
                                                            _vm.hasDraw(
                                                              fosport.events
                                                            ),
                                                          isbig3coupon: _vm.isBig3Coupon(
                                                            fosport.events
                                                          ),
                                                          couponname:
                                                            _vm.marketgroup
                                                              .marketgroupname,
                                                          isOddsBoost:
                                                            _vm.isOddsBoost
                                                        }
                                                      }
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.eventsGrouping === "NONGROUPEDEVENTS" &&
          _vm.filteredPrematchEvents
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExpanded,
                      expression: "isExpanded"
                    }
                  ],
                  staticClass: "coupon non-grouped"
                },
                [
                  !_vm.filteredPrematchEvents[0].markets[0].isoutright
                    ? _c(
                        "div",
                        [
                          _vm.anyEventWithOddsBoostMarketsExist(
                            _vm.fosport.events
                          )
                            ? _c("odds-boost-markets-header", {
                                attrs: {
                                  coupontitle: _vm.marketgroup.marketgroupname,
                                  idfosporttype: _vm.getIDFOSportType(
                                    _vm.filteredPrematchEvents[0]
                                  ),
                                  idfosport:
                                    _vm.filteredPrematchEvents &&
                                    _vm.filteredPrematchEvents[0] &&
                                    _vm.filteredPrematchEvents[0].idfosport
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.filteredPrematchEvents, function(
                            event,
                            $index
                          ) {
                            return _vm.eventHasOddsBoostMarkets(event)
                              ? _c(
                                  "div",
                                  {
                                    key: $index,
                                    class: [
                                      "event",
                                      {
                                        last:
                                          $index ===
                                          _vm.filteredPrematchEvents.length - 1
                                      },
                                      {
                                        "big-three-one-selection-per-event":
                                          _vm.isBig3Coupon(
                                            _vm.filteredPrematchEvents
                                          ) &&
                                          _vm.maxNumberOfMarkets(
                                            _vm.filteredPrematchEvents
                                          ) === 1
                                      }
                                    ]
                                  },
                                  [
                                    _c("odds-boost-coupon-event", {
                                      attrs: {
                                        event: event,
                                        twoselections:
                                          !_vm.isBig3Coupon(
                                            _vm.filteredPrematchEvents
                                          ) &&
                                          !_vm.hasDraw(
                                            _vm.filteredPrematchEvents
                                          ),
                                        threeselections:
                                          !_vm.isBig3Coupon(
                                            _vm.filteredPrematchEvents
                                          ) &&
                                          _vm.hasDraw(
                                            _vm.filteredPrematchEvents
                                          ),
                                        isbig3coupon: _vm.isBig3Coupon(
                                          _vm.filteredPrematchEvents
                                        ),
                                        couponname:
                                          _vm.marketgroup.marketgroupname,
                                        isOddsBoost: _vm.isOddsBoost
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1348faf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1348faf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/oddsBoost/oddsBoostMarketGroup.vue
// module id = null
// module chunks = 